import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Button} from '@/components/ui/button/Button'

export const StyledNotificationItem = styled(Flexbox)<{$isAlert?: boolean}>(
    ({theme: {palette, spacing}, $isAlert}) => `
        padding: ${spacing * 4}px;
        cursor: pointer;
        transition: background-color 0.2s ease-in-out;
        background-color: ${$isAlert ? palette.orange['100'] : palette.neutral.white};
        &:hover {
            background-color: ${palette.neutral['50']};
        }
        
    `
)

export const StyledNotificationTime = styled.span(
    ({theme: {typography, palette}}) => `
        ${typography.textXs};
        color: ${palette.neutral['500']};
    `
)

// The "primary" variant (unread state, "Segna come letto") uses the theme's
// primary/600 by default — override it to match StyledNotificationUnreadDot's
// color (primary/500, #3b82f6) at rest, hover and press alike.
export const StyledMarkReadButton = styled(Button)`
    ${({variant}) =>
        variant === 'primary' &&
        css`
            background: #3b82f6 !important;

            &:hover {
                background: #3b82f6 !important;
            }

            &:active,
            &.active {
                background: #3b82f6 !important;
            }
        `}
`

export const StyledNotificationUnreadDot = styled.div(
    ({theme: {palette}}) => `
        min-width: 8px;
        width: 8px;
        height: 8px;
        background-color: ${palette.primary['500']};
        border-radius: 50%;
    `
)
